import React from 'react';
import ReactDOM from 'react-dom';
import { APPLICATION_ROOT } from '../utility';

// By default run a11y compliance across the entire application
const DEFAULT_APP_CONTEXT = {
	include: [[`#${APPLICATION_ROOT}`]]
};

const DEFAULT_CONFIG = {
	branding: {
		// optional: adds application branding to the vulnerability URLs when issues are logged
		application: process.env.REACT_APP_NAME
	}
};

export const AXE_TIMEOUT = 1000;

/**
 * initiates accessibility testing within the application.  Defaults to analyzing the entire app from the root id.
 *
 * implementation uses @axe-core/react
 * https://github.com/dequelabs/axe-core-npm/tree/develop/packages/react
 *
 * @param context https://github.com/dequelabs/axe-core/blob/master/doc/API.md#context-parameter
 * @param config https://github.com/dequelabs/axe-core/blob/master/doc/API.md#api-name-axeconfigure
 */
function axeRegister(context = DEFAULT_APP_CONTEXT, config = DEFAULT_CONFIG) {
	if (process.env.NODE_ENV !== 'production') {
		const axe = require('@axe-core/react');
		axe(React, ReactDOM, AXE_TIMEOUT, config, context);
	}
}

export default axeRegister;
